import { createOwnPending } from "api/Pendings";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useStoreOwnPending = () => {
    const queryClient = useQueryClient();

    return useMutation(createOwnPending, {
        onSuccess: () => {
            toast.success("Created Successfully");
            queryClient.invalidateQueries("ownPendings");
        },
        onError: () => {
            toast.error("Failed to store pending");
        },
    });
};
